import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const TaxiAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.taxi} />

export default TaxiAppDevelopment
